export enum UnitOfMeasurement {
    Imperial = 'Imperial',
    UK_Imperial = 'UK_Imperial',
    Metric = 'Metric'
}
